import { useParams } from 'react-router-dom'
import { useStateValue } from 'providers'
import { ChatPanel } from './components/panel'
import { RequireUsername } from './components/require-username'
import { useLocationChat } from './use-location-chat'

// Chat for an admin moderating a place (`/admin/places/:slug`).
export const AdminChat = () => {
  const [
    {
      session: { user }
    }
  ] = useStateValue()
  const { slug } = useParams()
  const { comments, send } = useLocationChat(`/admin/locations/${slug}`)

  return (
    <RequireUsername user={user}>
      <ChatPanel comments={comments} currentUserId={user.id} onSend={send} />
    </RequireUsername>
  )
}
